import { Catalogue, ResponseError } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { FETCH_PRODUCT_DETAILS_REQUEST, FETCH_PRODUCT_DETAILS_SUCCESS, FETCH_PRODUCT_DETAILS_ERROR } from '../constants/ActionTypes'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'

import type { Dispatch } from 'redux'
import type { StoreState } from 'app/state/types'
import type { Product } from 'app/types/common-types'

type GetDetailsByPartNumberResponseData = {
    products: Product[]
}

export default function fetchProductDetails(partNumber: string, isRecommendation: boolean) {
    return (dispatch: Dispatch, getState: () => StoreState, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const options = {
            locale: state?.locale?.locale,
        }

        dispatch(fetchProductDetailsRequest(partNumber))

        const request = Catalogue.getDetailsByPartNumber({ partNumber, ...watsonConfig, options })

        return delay(timeout(fetch(request), getTimeout(state)), getDelay(state))
            .then((response: Response) => {
                if (!response.ok) {
                    throw new ResponseError(response)
                }
                return response.json()
            })
            .then((data: GetDetailsByPartNumberResponseData) => {
                if (data.products.length) {
                    const product = data.products[0]
                    dispatch(fetchProductDetailsSuccess(partNumber, {...product, isRecommendation}))

                    return product
                }

                throw new Error('Not Found')
            })
            .catch((error: unknown) => {
                dispatch(fetchProductDetailsError(partNumber, error))
                throw error
            })
    }
}

function fetchProductDetailsRequest(partNumber: string) {
    return {
        type: FETCH_PRODUCT_DETAILS_REQUEST,
        partNumber,
    }
}

function fetchProductDetailsSuccess(partNumber: string, payload: Product) {
    return {
        type: FETCH_PRODUCT_DETAILS_SUCCESS,
        partNumber,
        payload,
    }
}

function fetchProductDetailsError(partNumber: string, error) {
    return {
        type: FETCH_PRODUCT_DETAILS_ERROR,
        partNumber,
        error,
    }
}
